module.exports = __webpack_public_path__ + "static/media/640X360_Eng.a.b39cfc78.jpg";